<template>
  <div v-if="currentSourcing">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Projet</span>
                  </td>
                  <td>
                    {{ currentSourcing.projet }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date début</span>
                  </td>
                  <td>
                    {{ currentSourcing.date_debut }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentSourcing.document.created_by.prenom
                        ? currentSourcing.document.created_by.prenom +
                          ' ' +
                          currentSourcing.document.created_by.nom
                        : currentSourcing.document.created_by.nom
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date fin</span>
                  </td>
                  <td>
                    {{ currentSourcing.date_fin }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col-md-12">
          <table class="card table table-sm">
            <thead>
              <tr class="d-flex">
                <th class="col-4">Référence</th>
                <th class="col-5">Désignation</th>
                <th class="col-3 text-center">Quantité</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in currentSourcing.item_lists"
                :key="index"
                class="d-flex"
              >
                <td class="col-4" style="vertical-align: middle">
                  {{ item.reference }}
                </td>
                <td class="col-5" style="vertical-align: middle">
                  {{ item.designation }}
                </td>
                <td class="col-3 text-center" style="vertical-align: middle">
                  {{ item.quantite + ' ' + item.unite }}
                </td>
              </tr>
              <tr v-if="currentSourcing.item_lists.length === 0" class="d-flex">
                <td colspan="4" class="text-center col-12">Aucune donnée</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters('sourcing', ['currentSourcing']),
  },
  methods: {
    ...mapActions('sourcing', ['getSourcing']),
    init() {
      this.getSourcing(this.$route.params.id);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
